// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jVTF63CFERIksOPI50lr {
  width: 100%;
  height: 100%;
  background-color: white;
  padding: 16px;
  border-radius: 8px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  row-gap: 32px;
  max-height: calc(100vh - 18rem);
}

.wjE17S2gznkvlJhMt9p6 {
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  width: fit-content;
}

.Toa0SBdRWXrL59Pg2pp2 {
  width: fit-content;
}

.XsXDyMDkM8Z_xyQk_CjR {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.dzVTyHmavBvau6H6yGRG {
  overflow-y: auto;
  max-height: 80%;
  height: fit-content;
}

.a0_69uWvO985TcCyBJ8F {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.v25xnVSsgeyk5GUgCY1Y {
  width: 30%;
}

.RrmSFBT_mX13uE1_CgIm {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: black;
  font-size: 14px;
  font-family: "Chakra Petch";
  width: 70%;
  padding-right: 16px;
  padding-left: 16px;
  font-weight: 600;
}

.LzcPzL2MDsQg5mme4fIi {
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.D8Gsi0fG0uH5VKFcLQkt {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.wBYq05vBHusqPBb_CFc7 {
  width: 50px;
  height: 50px;
}`, "",{"version":3,"sources":["webpack://./src/screens/UserAdministration/UserAdministration.module.scss"],"names":[],"mappings":"AACA;EACI,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,+BAAA;AAAJ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;AADJ;;AAIA;EACI,kBAAA;AADJ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AADJ;;AAIA;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;AADJ;;AAIA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AADJ;;AAIA;EACI,UAAA;AADJ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,2BAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AADJ;;AAIA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AADJ;;AAIA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AADJ;;AAIA;EACI,WAAA;EACA,YAAA;AADJ","sourcesContent":["\r\n.userAdminContainer {\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: white;\r\n    padding: 16px;\r\n    border-radius: 8px;\r\n    overflow-y: auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    row-gap: 32px;\r\n    max-height: calc(100vh - 18rem);\r\n\r\n}\r\n\r\n.userAdministrationActions {\r\n    display: flex;\r\n    flex-direction: row;\r\n    gap: 16px;\r\n    align-items: center;\r\n    width: fit-content;\r\n}\r\n\r\n.userAdministrationSwitch {\r\n    width: fit-content;\r\n}\r\n\r\n.userAdminHeader {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    width: 100%;\r\n}\r\n\r\n.idoTableContainer {\r\n    overflow-y: auto;\r\n    max-height: 80%;\r\n    height: fit-content;\r\n}\r\n\r\n.cadetWalletToolbar {\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.filterContainer {\r\n    width: 30%;\r\n}\r\n\r\n.walletStatistics {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    color: black;\r\n    font-size: 14px;\r\n    font-family: \"Chakra Petch\";\r\n    width: 70%;\r\n    padding-right: 16px;\r\n    padding-left: 16px;\r\n    font-weight: 600;\r\n}\r\n\r\n.idoTableFooter {\r\n    width: 100%;\r\n    height: 50px;\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.editIDOContainer {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.profileImage {\r\n    width: 50px;\r\n    height: 50px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"userAdminContainer": `jVTF63CFERIksOPI50lr`,
	"userAdministrationActions": `wjE17S2gznkvlJhMt9p6`,
	"userAdministrationSwitch": `Toa0SBdRWXrL59Pg2pp2`,
	"userAdminHeader": `XsXDyMDkM8Z_xyQk_CjR`,
	"idoTableContainer": `dzVTyHmavBvau6H6yGRG`,
	"cadetWalletToolbar": `a0_69uWvO985TcCyBJ8F`,
	"filterContainer": `v25xnVSsgeyk5GUgCY1Y`,
	"walletStatistics": `RrmSFBT_mX13uE1_CgIm`,
	"idoTableFooter": `LzcPzL2MDsQg5mme4fIi`,
	"editIDOContainer": `D8Gsi0fG0uH5VKFcLQkt`,
	"profileImage": `wBYq05vBHusqPBb_CFc7`
};
export default ___CSS_LOADER_EXPORT___;
